import {getFeatureFlagVariant} from "./feature_flag_store";
import {experiment} from "./init_amplitude";
import {trackAmplitudeEvent} from "./track_amplitude_event";

/**
 * Records an Amplitude Experiment exposure for the given flag key.
 * Prefers the Experiment SDK (`$exposure` via analytics integration); falls back to manual track when the client is unavailable.
 */
export const trackAmplitudeExperimentExposure = (flagKey: string): void => {
    const experimentClient = experiment();

    if (experimentClient) return experimentClient.exposure(flagKey);

    const variant = getFeatureFlagVariant(flagKey);

    if (!variant || variant === "off") return;

    trackAmplitudeEvent("$exposure", {
        flag_key: flagKey,
        variant
    });
};
import {getFeatureFlagVariant} from "./feature_flag_store";
import {experiment} from "./init_amplitude";
import {trackAmplitudeEvent} from "./track_amplitude_event";

/**
 * Records an Amplitude Experiment exposure for the given flag key.
 * Prefers the Experiment SDK (`$exposure` via analytics integration); falls back to manual track when the client is unavailable.
 */
export const trackAmplitudeExperimentExposure = (flagKey: string): void => {
    const experimentClient = experiment();

    if (experimentClient) return experimentClient.exposure(flagKey);

    const variant = getFeatureFlagVariant(flagKey);

    if (!variant || variant === "off") return;

    trackAmplitudeEvent("$exposure", {
        flag_key: flagKey,
        variant
    });
};
